import { useAsyncEffect } from '@ocx/utils';

import { useAppRatePendingState } from '../../../modules/app-rate/useAppRatePendingState';
import { useAppRateDialog } from '../../../modules/app-rate/useAppRateDialog';
import { useShowAppRatingOnDiscountOfferFulfilled } from '../../../modules/app-rate/useShowAppRatingOnDiscountOfferFulfilled';

export const useHomeAppRateEffect = () => {
  const { open: openAppRateDialog } = useAppRateDialog();
  const [getIsAppRatePending] = useAppRatePendingState();
  useShowAppRatingOnDiscountOfferFulfilled();

  useAsyncEffect(
    async (signal) => {
      const isPending = await getIsAppRatePending();
      if (!signal.aborted && isPending) {
        openAppRateDialog();
      }
    },
    [getIsAppRatePending, openAppRateDialog],
  );
};
